import React, { FC } from 'react';

import PropTypes from 'prop-types';

import { LinkButton } from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-helpers';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';

const VARIANTS = {
  PROJECTS: 'projects',
  TEMPLATES: 'templates',
} as const;

type ProjectsErrorProps = {
  variant?: typeof VARIANTS[keyof typeof VARIANTS];
  projectsCount?: number;
  retry?: () => void;
};

const ProjectsError: FC<ProjectsErrorProps> = ({
  retry,
  projectsCount,
  variant,
}) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  const translationKey =
    variant === VARIANTS.TEMPLATES
      ? 'TEMPLATES_ERROR_MESSAGE'
      : 'PROJECTS_ERROR_MESSAGE';
  return (
    <div
      css={[
        {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: 64,
          padding: '0 28px 0 27px',
        },
      ]}
    >
      <AlertWarningIcon
        style={{
          flexShrink: 0,
        }}
      />
      <div
        css={[
          {
            paddingLeft: 8,
          },
        ]}
      >
        <span
          css={[
            theme.typography.bodySmall,
            {
              color: theme.colors.charcoal700,
              paddingRight: 5,
            },
          ]}
        >
          {T.translate(translationKey, { context: projectsCount })}
        </span>
        <LinkButton onClick={retry}>
          <span css={[theme.typography.bodySmall]}>
            {T.translate('TRY_AGAIN')}
          </span>
        </LinkButton>
      </div>
    </div>
  );
};

ProjectsError.displayName = 'ProjectsError';

ProjectsError.propTypes = {
  retry: PropTypes.func,
  projectsCount: PropTypes.number,
  variant: PropTypes.oneOf(Object.values(VARIANTS)),
};

export default Object.assign(ProjectsError, {
  VARIANTS,
});
